import {PaginatedContent} from '../../../application/contentLoaders/paginatedContent';
import {VoteRating} from '../../../application/vote/voteRating';
import {ReadyProvider} from '../../../application/providers/readyProvider';
import {ScrollTo} from '../../../application/scrollTo';
import {LazyYoutubeVideos} from '../../../application/lazyLoad/lazyYoutubeVideos';
import {CommentDeleteButtons} from '../../../application/comment/commentDeleteButtons';
import {FormWithRating} from '../../../application/forms/formWithRating';

ReadyProvider.executeOnReady(() => {
    new VoteRating(document.querySelector('[data-vote="form"]'));
    new FormWithRating(document.querySelector('[data-comment="form"]'));
    new CommentDeleteButtons(document.querySelectorAll('[data-comment="delete"]'));

    new PaginatedContent(document.querySelector('[data-page="content"]'));
    new PaginatedContent(document.querySelector('[data-brand="deals"]'));
    ScrollTo.init();

    ReadyProvider.executeWithLazy(() => {
        LazyYoutubeVideos.load();
    });
});
